import { TAQLStore } from '@monorepo/types';
import { TAQLStoreActionsType, TAqlStoreActions } from './aql-db.actions';
import produce from 'immer';
import { INITIAL_CACHE_RESET_TIMESTAMP } from '../metadata/metadata.reducer';
export const SAVED_EVENTS_CACHE_STORAGE_TIME = 3 * 24 * 60 * 60 * 1000;

export function getAqlStoreInitalState(nextCacheResetTimestamp: number) {
  const aqlStoreInitalState: TAQLStore = {
    lockDetails: {
      isLocked: false,
      lockedBy: 'NONE',
    },
    aqlDB: {
      sizeQtyList: [],
      nextCacheResetTimestamp: nextCacheResetTimestamp,
      dailyCache: {
        completedEvents: {
          lineMap: {},
        },
        currentWeekFailedEvents: [],
        recentCategoryList: {},
      },
      persistanceCache: {
        savedEvents: {
          lineMap: {},
        },
      },
    },
  };
  return aqlStoreInitalState;
}

export function AQLStoreStateReducer(
  state: TAQLStore = getAqlStoreInitalState(INITIAL_CACHE_RESET_TIMESTAMP),
  action: TAqlStoreActions,
): TAQLStore {
  switch (action.type) {
    case TAQLStoreActionsType.UpdateAqlStoreLockDetails: {
      return produce(state, (draft) => {
        draft.lockDetails = action.lockDetails;
      });
    }
    case TAQLStoreActionsType.UpdateAqlStoreAndReleaseLock:
    case TAQLStoreActionsType.UpdateAqlStoreAndReleaseLockAndFetchWeeklyFailedEvents:
      console.log(action);
      {
        return produce(state, (draft) => {
          draft.aqlDB = action.aqlDB;
          draft.lockDetails = {
            isLocked: false,
            lockedBy: 'NONE',
          };
        });
      }
    default:
      return state;
  }
}
